import mixins from '@synergycms_core/less/mixins';
export default {
  firstRowFooter: {},
  flexRowFooter: {},
  roomsDetail: {},
  roomsDetailFlex: {},
  roomDetailLine: {},
  roomDetail: {},
  roomDetailDescription: {},
  roomDetailCheck: {},
  selectIcon: {},
  secondRowFooter: {},
  deleteService: {},
  servicePrice: {},
  servicePriceSelected: {},
  serviceBookButton: {},
  defaultStyle: {
    display: 'block',
    background: '#fff',
    border: '0',
    padding: '0'
  },
  hide: {
    display: 'none'
  },
  serviceHeader: {
    '@media (min-width:801px)': {
      position: 'relative',
    }
  },
  serviceInfoWithImage: {
    padding: '10px 10px 17px',
    '& > div:last-of-type': {
      marginTop: '10px',
    },
    '&:lang(ar)': {
      '@media (min-width:801px)': {
        marginRight: "220px",
        marginLeft: "20px"
      }
    },
    '@media (min-width:801px)': {
      padding: '20px 0 16px',
      margin: '0 20px 0 220px',
      minHeight: '163px',
      boxSizing: 'content-box !important',
      minWidth:'320px',
      '& > div:last-of-type': {
        fontSize: '16px',
        marginTop: '4px'
      }
    }
  },
  serviceInfo: {
    padding: '20px 20px 16px',
    '@media (min-width:801px)': {
      minWidth:'320px',
    }
  },
  serviceFooter: {
    textAlign: 'right',
    '& $firstRowFooter': {
      display: 'table',
      width: '100%',
      '& $roomsDetail': {
        '@media (min-width:801px)': {
          padding: '15px 20px',
          border: 'none'
        },
        width: '100%',
        padding: '10px',
        borderBottom: '1px solid #d8d8d8',
        boxSizing:'border-box',

        '& $roomDetailLine': {
          '@media (min-width:801px)': {
            background: '#f2f2f2',
            padding: '0',
            display: 'table',
            width: '100%'
          },
          position: 'relative',
          background: '#f2f2f2',
          padding: '15px 10px 20px 10px',
          '& $roomDetail,& $roomDetailDescription,& $roomDetailCheck': {
            '@media (min-width:801px)': {
              display: 'table-cell',
              verticalAlign: 'middle',
              padding: '10px',
              height: '40px'
            }
          },
          '& $roomDetail': {
            textAlign: 'left',
            '&:lang(ar)': {
              textAlign: 'right',
              '@media (min-width:801px)': {
                paddingRight: '20px',
                paddingLeft: '0'
              }
            },
            '@media (min-width:801px)': {
              paddingLeft: '20px',
              '& > span': {
                fontSize: '20px'
              }
            }
          },
          '& $roomDetailDescription': {
            padding: '0 60px 7px 0',
            textAlign: 'left',
            '& > span': {
              font: data => '300 13px ' + data.fontFamily1
            },
            '&:lang(ar)': {
              padding: '0 0 7px 60px',
              textAlign: 'right',
              '@media (min-width:801px)': {
                textAlign: 'left'
              }
            },
            '@media (min-width:801px)': {
              textAlign: 'right',
              '& > span': {
                fontSize: '16px',
                color: '#8c8c8c'
              }
            }
          },
          '& $roomDetailCheck': {
            position: 'relative',
            '@media (min-width:801px)': {
              width: '260px',
              textAlign: 'right',
              paddingLeft: '0',
              position: 'relative'
            },
            '& label': {
              position: 'absolute',
              right: '30px',
              top: '50%',
              height: '22px',
              width: '22px',
              background: '#fff',
              marginTop: '-22px',
              border: '1px solid #ddd',
              WebkitBoxShadow: '0 0 9px -3px #000',
              MozBoxShadow: '0 0 9px -3px #000',
              boxShadow: '0 0 9px -3px #000',
              padding: '0',
              '&:before': {
                content: 'none'
              },
              '& input': {
                position: 'fixed',
                top: '0',
                left: '-999px',
                width: '0',
                height: '0',
                opacity: '0',
                '&:lang(ar)': {
                  left: "auto",
                  right: "-999px"
                }
              },
              '& span:after': {
                content: "'e04d'",
                font: '7px/22px Icons',
                position: 'absolute',
                left: '0',
                top: '0',
                right: '0',
                textAlign: 'center',
                color: 'transparent',
                WebkitTransition: '0.3s',
                OTransition: '0.3s',
                MsTransition: '0.3s',
                MozTransition: '0.3s',
                transition: '0.3s',
                width: 'auto'
              },
              'input:checked ~ span:after': {
                fontSize: '12px',
                color: data => data.mainColor
              },
              '&:lang(ar)': {
                left: "30px",
                right: "auto"
              },
              '@media (min-width:801px)': {
                marginTop:'0',
                '@supports (-webkit-appearance:none)': {
                  marginTop:'-11px'
                },
              }
            },
            '& $selectIcon': {
              fontSize: '13px',
              position: 'absolute',
              right: '19px',
              marginTop: '-9px',
              top: '50%',
              color: data => data.mainColor,
              pointerEvents:'none',
              '&:lang(ar)': {
                left: "19px",
                right: "auto"
              }
            },
            '& select': {
              extend: mixins.appearanceNone(),
              padding: '12px 25px 11px 15px',
              width: '100%',
              border: 'none',
              cursor: 'pointer',
              background: '#fff',
              font: data => '300 13px/1.38 ' + data.fontFamily1,
              boxSizing: 'border-box',
              '&:lang(ar)': {
                paddingLeft: "15px",
                paddingRight: "25px"
              }
            },
            '&:lang(ar)': {
              '@media (min-width:801px)': {
                paddingRight: '0',
                textAlign: 'left'
              }
            }
          },
          '&:not(:last-of-type)': {
            marginBottom: '10px'
          }
        }
      },
      '& $roomsDetailFlex': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        '& $roomDetailLine': {
          display: 'flex',
          flexDirection: 'row',
        }
      }
    },
    '& $flexRowFooter': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    '& $secondRowFooter': {
      '@media (min-width:801px)': {
        padding: '15px 20px'
      },
      padding: '10px 0 13px',
      display: 'table',
      width: '100%',
      boxSizing:'border-box',
      '& $deleteService,& $servicePrice': {
        display: 'table-cell',
        verticalAlign: 'middle',
        padding: '0 10px',
        textAlign: 'left',
      },
      '& $deleteService': {
        padding: '0px',
        '& > button': {
          padding: '0 10px',
        },
        '&:lang(ar)': {
          textAlign: 'right',
          '& > button': {
            '& > span': {
              display: 'flex',
              '& > span': {
                marginRight: '0',
                marginLeft: '5px'
              }
            }
          }
        }
      },
      '& $servicePrice': {
        paddingRight: '10px',
        paddingLeft: '10px',
        textAlign: 'left',
        '& > span': {
          display: 'block'
        },
        '@media (min-width:801px)': {
          width: '100%',
          textAlign: 'right',
          paddingRight: '10px',
        },
        '&:lang(ar)': {
          paddingLeft: '10px',
          paddingRight: 0,
          textAlign: 'left',
        }
      },
      '& $servicePriceSelected': {
        textAlign: 'right',
      },
      '& $serviceBookButton': {
        display: 'table-cell',
        verticalAlign: 'middle',
        paddingRight: '10px',
        '& > button': {
          minWidth: '140px',
          height: '40px',
          font:"16px 'Roboto', sans-serif",
          '@media (min-width:801px)': {
            '& > button': {
              width: '140px'
            }
          }
        },
        '@media (min-width:801px)': {
          paddingRight: '0'
        },
        '&:lang(ar)': {
          paddingLeft: '10px',
          paddingRight: 0
        }
      }
    },
    '@media (min-width:801px)': {
      padding: '0'
    },
    '&:lang(ar)': {
      textAlign: 'left'
    }
  },
  positionImage: {
    display: 'none',
    '@media (min-width:801px)': {
      display: 'block',
      position: 'absolute',
      top: '0',
      left: '0',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      width: '200px',
      height: '200px'
    },
    '&:lang(ar)': {
      '@media (min-width:801px)': {
        left: 'auto',
        right: 0
      }
    }
  },
  showMoreButton:{
    maxHeight:'auto',
    overflow:'hidden'
  },
  showLessButton:{
    maxHeight:'100px',
    overflow:'hidden'
  },
  showMoreShadow:{
    position:'relative',
    zIndex:'1',
    '&:after':{
      content:`''`,
      position:'absolute',
      left:'0',
      right:'0',
      bottom:'100%',
      zIndex:'-1',
      height:'35px',
      background:'linear-gradient(0deg, #fff 0%, rgb(255 255 255) 30%, rgba(255,255,255,0) 100%)'
    }
  }
};
